var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWifi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C7C7C7;}\n\t.st1{fill:#449B23;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11",
    className: "st0",
    d: "M4.47,17.11l-2.58-2.46c10.29-9.66,26.32-9.66,36.61,0l-2.58,2.46 C27.08,8.82,13.32,8.82,4.47,17.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_12",
    className: "st0",
    d: "M8.85,21.88l-2.61-2.46c7.9-7.25,20.03-7.25,27.93,0l-2.61,2.46 C25.13,15.98,15.26,15.98,8.85,21.88z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_13",
    className: "st0",
    d: "M14.3,27.06l-2.46-2.46c4.62-4.61,12.1-4.61,16.72,0l-2.46,2.46 C22.83,23.81,17.56,23.81,14.3,27.06z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_346",
    className: "st0",
    cx: 20.15,
    cy: 29.72,
    rx: 3.09,
    ry: 3.09
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_639",
    x: 5.39,
    y: 24.84,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -18.7296 14.0474)",
    className: "st1",
    width: 4.41,
    height: 9.59
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_640",
    x: 6.1,
    y: 25.87,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -16.0152 17.4833)",
    className: "st1",
    width: 14,
    height: 4.41
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifi);
export default __webpack_public_path__ + "static/media/wifi.9dbcc2923e9db8607abadbd3afabcbfb.svg";
export { ForwardRef as ReactComponent };